type Payload = {
  newScale: number
  oldScale: number
  pointer: number[]
  ref: HTMLElement | null
  translate: number[]
}

type Scale = number[]

const scale = (payload: Payload): Scale => {
  if (payload.ref) {
    const { newScale, oldScale, pointer, ref, translate } = payload

    const cx = window.innerWidth / 2
    const cy = ref.offsetTop + ref.offsetHeight / 2

    const px = pointer[0]
    const py = pointer[1]

    const tx = translate[0]
    const ty = translate[1]

    const pointerX = px - cx
    const pointerY = py - cy

    const pointToX = (pointerX - tx) / oldScale
    const pointToY = (pointerY - ty) / oldScale

    const mousePointTo = [pointToX, pointToY]

    const posX = pointerX - mousePointTo[0] * newScale
    const posY = pointerY - mousePointTo[1] * newScale

    return [posX, posY]
  }

  return [0, 0]
}

export default scale
